import { React, Locale } from '../../libraries';
import { Modal } from 'react-bootstrap';

const DescModal = ({
    showModal,
    handleClose,
    messageDesc,
    messageTerm
}) => {
    const { t } = Locale();


    return (
        <>

            <Modal
                show={showModal}
                onHide={() => handleClose()}
                dialogClassName="custom-modal customModalDesc"
            >
                <Modal.Header
                    closeButton
                    className="headerLine"
                    onClick={() => handleClose()}
                />
                <Modal.Body>
                    <div className="text-center">
                        <div className='desc-heading-outer'>
                            <div className='desc-heading-inner'>
                                <div className='desc-heading'>
                                    {t('ServiceField.serviceDescinEng')} :-
                                </div>
                                <div className="desc-message mt-1">
                                    <div
                                      className="ql-editor"
                                    dangerouslySetInnerHTML={{ __html: messageDesc }} />
                                </div>
                            </div>
                            <div className='desc-heading-inner'>
                                <div className='desc-heading'>
                                    {t('field.termCond')}  :-
                                </div>
                                <div className="desc-message mt-1">
                                    <div
                                      className="ql-editor"
                                    dangerouslySetInnerHTML={{ __html: messageTerm }} />

                                </div>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>


        </>
    );
};

export default DescModal;
